module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showLarge) ? _c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('span', {
    class: _vm.getIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body information-modal-body ",
    staticStyle: {
      "height": "100px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])]) : _c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "460px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('span', {
    class: _vm.getIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body information-modal-body ",
    staticStyle: {
      "height": "100px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v(_vm._s(_vm.textYes))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7056e163","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/information-icon-modal.vue
// module id = 1027
// module chunks = 0